import {
  COMPREHENSIVE_EVALUATION_LABEL,
  RECOMMENDED_MARGIN_LABEL,
  NARROWING_DOWN,
  SORTING,
  SEARCHING,
  COMPREHENSIVE_EVALUATION,
  FUNCTION_DESCRIPTION,
  DISPLAY_DESCRIPTION,
  ONE_YEAR_ID,
  SIX_MONTH_ID,
  THREE_MONTH_ID,
  THREE_YEAR_ID,
  MARGIN_REQUIRED,
} from '.';

export const RANGE_OUT_ALERT_MESSAGE = 'このルールは現在レンジアウトしています';
export const ADD_TO_CART = 'カートに追加';
export const RUN_NOW = '確認画面へ進む';
export const RECOMMENDATION = 'おすすめ';
export const CONFIRM_MESSAGES = Object.freeze([
  'ビルダーズシェアは当社が作成した自動売買ではございません。',
  '設定内容をよくご確認いただいた上で運用をご検討ください。',
]);
export const CONFIRM_MESSAGES_FOR_BUILD = Object.freeze([
  'ビルダーズシェアは当社が作成した自動売買ではございません。',
  '設定内容をよくご確認いただいた上で運用をご検討ください。',
]);
export const CONFIRM_MESSAGES_FOR_TRENDFOLLOW = Object.freeze([
  'この自動売買は短期向けの戦略です。',
  'ご自身の投資スタイルや相場予測とあわせてご利用ください。',
]);

export const MESSAGE_NO_RESULT = '条件に一致する自動売買ルールが見つかりませんでした。';

export const HOW_TO_READ_CARD_TITLE_LINES = [FUNCTION_DESCRIPTION, DISPLAY_DESCRIPTION];
export const HOW_TO_READ_CARD_BOLD_LINES = [
  NARROWING_DOWN,
  SORTING,
  SEARCHING,
  COMPREHENSIVE_EVALUATION,
  MARGIN_REQUIRED,
];
export const HOW_TO_READ_CARD = [
  FUNCTION_DESCRIPTION,
  NARROWING_DOWN,
  '　運用の目安となる資金や総合評価を指定してルールを検索できます。',
  SORTING,
  '　総合評価順、収益率順または人気順で並び替えできます。',
  SEARCHING,
  '　選択しているカテゴリに対して、ルール名で検索できます。',
  DISPLAY_DESCRIPTION,
  COMPREHENSIVE_EVALUATION,
  '　1～5',
  '　シミュレーションにおける最大ドローダウン、収益率、取引頻度、レンジ位置を総合的に評価し、5段階評価で表しています。',
  '　評価の数字が大きいほどルールの総合力が高いと考えられます。',
  MARGIN_REQUIRED,
  '　個人のお客様向けの証拠金率と前日終値をもとに算出した、発注時に必要となる資金の目安です。',
];

export const HOW_TO_READ_CARD_TITLE_LINES_MOBILE = [FUNCTION_DESCRIPTION, DISPLAY_DESCRIPTION];
export const HOW_TO_READ_CARD_BOLD_LINES_MOBILE = [
  NARROWING_DOWN,
  SORTING,
  SEARCHING,
  COMPREHENSIVE_EVALUATION,
  MARGIN_REQUIRED,
];
export const HOW_TO_READ_CARD_MOBILE = [
  FUNCTION_DESCRIPTION,
  NARROWING_DOWN,
  '運用の目安となる資金や総合評価を指定してルールを検索できます。',
  '',
  SORTING,
  '総合評価順、収益率順または人気順で並び替えできます。',
  '',
  SEARCHING,
  '選択しているカテゴリに対して、ルール名で検索できます。',
  '',
  DISPLAY_DESCRIPTION,
  COMPREHENSIVE_EVALUATION,
  '1～5',
  'シミュレーションにおける最大ドローダウン、収益率、取引頻度、レンジ位置を総合的に評価し、5段階評価で表しています。',
  '評価の数字が大きいほどルールの総合力が高いと考えられます。',
  '',
  MARGIN_REQUIRED,
  '個人のお客様向けの証拠金率と前日終値をもとに算出した、発注時に必要となる資金の目安です。',
];

export const MARGINS = Object.freeze([
  Object.freeze({ id: '0', value: '50万円未満' }),
  Object.freeze({ id: '1', value: '50〜100万円未満' }),
  Object.freeze({ id: '2', value: '100〜200万円未満' }),
  Object.freeze({ id: '3', value: '200万円以上' }),
]);

export const PERIODS = Object.freeze([
  Object.freeze({ id: '0', value: '短期' }),
  Object.freeze({ id: '1', value: '中期' }),
  Object.freeze({ id: '2', value: '長期' }),
]);

export const COMPREHENSIVE_EVALUATIONS = Object.freeze([
  Object.freeze({ id: '1', value: '1' }),
  Object.freeze({ id: '2', value: '2' }),
  Object.freeze({ id: '3', value: '3' }),
  Object.freeze({ id: '4', value: '4' }),
  Object.freeze({ id: '5', value: '5' }),
]);

export const ID_RANGE_OUTS_EXCLUDE_RANGE_OUT = 'excludeRangeOut';
export const KEY_MARGINS = 'margins';
export const KEY_COMPREHENSIVE_EVALUATIONS = 'comprehensiveEvaluations';
export const KEY_RANGE_OUTS = 'rangeOuts';
export const TITLE_FILTER_CONDITION = '絞込';
export const TITLE_RECOMMENDED_MARGIN = RECOMMENDED_MARGIN_LABEL;
export const TITLE_COMPREHENSIVE_EVALUATION = COMPREHENSIVE_EVALUATION_LABEL;
export const TITLE_RANGE_OUT = 'レンジアウトを除く';
export const DESCRIPTION_RANGE_OUT = 'レンジアウトしていないルールが表示されます';
export const LABEL_CLEAR = '条件をクリア';
export const LABEL_OK = 'OK';

export const MULTI_STRATEGY = 'マルチ戦略';

const SHARE_RETURN_TAG_ID_FX = 1000;
export const TAG_ID_FX = 1;
export const SHARE_RETURN_TAG_ID_MAPPING = Object.freeze({
  [TAG_ID_FX]: SHARE_RETURN_TAG_ID_FX,
});

export const ORDER_RETURN = 0;
export const ORDER_POPULAR = 3;
export const ORDER_EVALUATION = 4;

export const SELECTION_OPTIONS = Object.freeze([
  Object.freeze({ label: '総合評価順', value: ORDER_EVALUATION }),
  Object.freeze({ label: '収益率順', value: ORDER_RETURN }),
  Object.freeze({ label: '人気順', value: ORDER_POPULAR }),
]);

export const SELECTION_OPTIONS_SELECTED_LABEL_MAP = SELECTION_OPTIONS.reduce((acc, cur) => {
  const selectedLabels = { [ORDER_EVALUATION]: '評価順' };
  const { value } = cur;
  const label = selectedLabels[value] ?? cur.label;
  return {
    ...acc,
    [value]: label,
  };
}, {});

export const SELECT_EXTERNAL_LINK_NAME = '解説';

// トレンド戦略_ロジックID
export const TREND_STRATEGY_LOGIC_ID = 15;

// デフォルト3か月（短期表示）
export const DEFAULT_THREE_MONTHS_LOGIC_ID_SHORT = 16;
// デフォルト6か月（短期表示）
export const DEFAULT_SIX_MONTHS_LOGIC_ID_SHORT = 17;
// デフォルト1年（長期表示）
export const DEFAULT_ONE_YEARS_LOGIC_ID_LONG = 22;
// デフォルト3年（長期表示）
export const DEFAULT_THREE_YEARS_LOGIC_ID_LONG = 23;

const TERM_OPTIONS_SHORT = Object.freeze([THREE_MONTH_ID, SIX_MONTH_ID]);
const TERM_OPTIONS_LONG = Object.freeze([ONE_YEAR_ID, THREE_YEAR_ID]);

// IDが15, 16, 17の場合、シミュレーション期間は「3か月」「6か月」のみ表示
// IDが22, 23の場合、シミュレーション期間は「1年」「3年」のみ表示
export const LOGIC_ID_TERM_OPTIONS_MAP = new Map([
  [TREND_STRATEGY_LOGIC_ID, TERM_OPTIONS_SHORT],
  [DEFAULT_THREE_MONTHS_LOGIC_ID_SHORT, TERM_OPTIONS_SHORT],
  [DEFAULT_SIX_MONTHS_LOGIC_ID_SHORT, TERM_OPTIONS_SHORT],
  [DEFAULT_ONE_YEARS_LOGIC_ID_LONG, TERM_OPTIONS_LONG],
  [DEFAULT_THREE_YEARS_LOGIC_ID_LONG, TERM_OPTIONS_LONG],
]);
